<template>
  <v-card
    class=" py-8 px-6 text-center"
    elevation="0">
    <v-card-title> パスワード再発行</v-card-title>

    <v-card-text class="mt-4">
      <!-- エラーメッセージ -->
      <v-alert
        v-if="props.error"
        type="error"
        variant="tonal"
        class="mb-8 text-left">
        {{ props.error }}
      </v-alert>

      <v-alert
        type="info"
        variant="tonal"
        class="mb-8 text-left">
        パスワードを再発行するための認証コードを送付します。IDとして登録されたメールアドレスを入力してください。
      </v-alert>

      <v-form
        ref="loginForm"
        v-model="sendable"
        @submit.prevent="submit">
        <v-text-field
          v-model="email"
          label="メールアドレス"
          variant="outlined"
          :rules="[rules.required]"
          :disabled="props.loading"
          clearable
          block>
        </v-text-field>

        <!-- v-switch パスワード表示切替 -->

        <v-btn
          :disabled="!sendable"
          :loading="props.loading"
          type="submit"
          class="my-4"
          variant="flat"
          color="primary"
          size="large"
          block>
          認証コード発行
        </v-btn>

        <v-btn
          color="primary"
          variant="tonal"
          size="large"
          @click="cancel"
          block>
          キャンセル
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps({
  loading: Boolean,
  error: String
});

const emit = defineEmits<{
  submit: [email: string];
  cancel: [];
}>();

const sendable = ref(false);
const email = ref('');

const rules = {
  required: (value) => !!value || '必須項目です'
};

async function submit() {
  emit('submit', email.value);
}

async function cancel() {
  emit('cancel');
}
</script>
